export type View =
  | 'landing'
  | 'login'
  // Lykke-EL Pro
  | 'pro-dashboard'
  | 'pro-leads'
  | 'pro-customers'
  | 'pro-customer-detail'
  | 'pro-quotes'
  | 'pro-quote-editor'
  | 'pro-jobs'
  | 'pro-job-detail'
  | 'pro-calendar'
  | 'pro-time'
  | 'pro-materials'
  | 'pro-invoices'
  | 'pro-employees'
  | 'pro-statistics'
  | 'pro-settings'
  // Shared tools
  | 'mester-ai'
  | 'quality'
  | 'quality-detail'
  | 'regelgrundlag'
  | 'users'
  | 'profile'

/** The view a nav item returns to when a detail screen is open. */
export const parentView: Partial<Record<View, View>> = {
  'pro-customer-detail': 'pro-customers',
  'pro-job-detail': 'pro-jobs',
  'pro-quote-editor': 'pro-quotes',
  'quality-detail': 'quality',
}
